import { useState, useEffect } from 'react';
// Defined in general.js
/* global isMobileView */
// Replacement for MobileMixin.js

function useMobileStatus() {
    const [isMobile, setMobile] = useState(false);

    const setMobileView = function () {
        setMobile(isMobileView());
    };

    useEffect(() => {
        $(window).on('orientationchange resize', setMobileView);
        setMobileView();

        return () => $(window).off('orientationchange resize', setMobileView);
    }, []);

    return [isMobile];
}
export default useMobileStatus;
